import { render, staticRenderFns } from "./ProcessHandoverView.vue?vue&type=template&id=cafb38d6&scoped=true"
import script from "./ProcessHandoverView.vue?vue&type=script&lang=ts"
export * from "./ProcessHandoverView.vue?vue&type=script&lang=ts"
import style0 from "./ProcessHandoverView.vue?vue&type=style&index=0&id=cafb38d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafb38d6",
  null
  
)

export default component.exports